import { Stack } from "@mui/material";
import React, { useContext } from "react";

import PaginationControlsV2 from "../../../../../../../../../global/PaginationControlsV2";
import { LawFirmsStateContext, LawFirmsDispatchContext } from "../context/LawFirmsProvider";
import { setCurrentPage, setOffset } from "../state/actions";

const Pagination = () => {
  const state = useContext(LawFirmsStateContext);
  const dispatch = useContext(LawFirmsDispatchContext);

  const handleChange = (event, value) => {
    setCurrentPage(dispatch, value);
    if (value === 1) {
      setOffset(dispatch, state.resLimit);
    }
    setOffset(dispatch, state.resLimit * (value - 1));
  };
  return (
    <div id="Pagination">
      {!state.fetchIsLoading && (
        <div className="flex flex-row justify-center">
          <div className={`float-left flex-none justify-start px-0 py-2`}>
            <span className="text-sm">
              Showing: {state.resultCount.current + " / " + state.resultCount.total}
            </span>
          </div>
          <div className={`flex w-full justify-center px-0 py-2 md:px-0`}>
            <Stack alignItems={"center"}>
              <PaginationControlsV2
                alignment={"center"}
                resultCount={state.resultCount.total}
                handleChange={handleChange}
                currentPage={state.currentPage}
                resultLimit={state.resLimit}
              />
            </Stack>
          </div>
        </div>
      )}
    </div>
  );
};
export default Pagination;
